"use client";

import { trace as mobxTrace } from "mobx";
import tilg from "tilg";

declare global {
  var useDebugComponent: () => (tmpl: TemplateStringsArray, ...args: unknown[]) => unknown;

  var trace: typeof mobxTrace;
}

if (process.env.NODE_ENV !== "production") {
  globalThis.useDebugComponent = typeof window === "undefined" ? () => {} : tilg;

  globalThis.trace = mobxTrace;
}
